import { Box, Text, VStack } from '@chakra-ui/react'
import { Button } from 'uikit'
import { useBoolean } from 'react-use'
import { Form, Modal, TextAreaForm } from 'uikit'
import { Field, Formik } from 'formik'
import * as Yup from 'yup'
import { useRemoveUser } from './services/useRemoveUser'

const validationSchema = Yup.object({
  userComment: Yup.string().required('Обязательное поле'),
})

export const RemoveUserModal = ({ userId }) => {
  const [isOpen, setOpenModal] = useBoolean(false)

  const { mutate, isLoading } = useRemoveUser(userId)

  const onSubmitHandle = (values) => {
    mutate(values, {
      onSuccess: () => {
        setOpenModal(false)
      },
    })
  }

  return (
    <>
      <Button width="100%" onClick={() => setOpenModal(true)} colorPalette="red" loading={isLoading}>
        Заблокировать
      </Button>
      <Modal isOpen={isOpen} onClose={() => setOpenModal(false)} title="Заблокировать пользователя">
        <VStack alignItems="flex-start" gap={4}>
          <Text fontSize="20px" color="red.500">
            Внимание!
          </Text>
          <Text>
            Данное действие нельзя будет отменить. Действие равносильно удалению аккаунта. При
            блокировке к телефону и email добавляется префикс _blocked.
          </Text>
          <Formik
            validateOnMount
            enableReinitialize
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={onSubmitHandle}
          >
            {({ handleSubmit, isValid }) => (
              <Form w="full">
                <Field
                  disabled={isLoading}
                  name="userComment"
                  placeholder="Введите комментарий"
                  component={TextAreaForm}
                />
                <Box pt="30px">
                  <Button
                    colorPalette="red"
                    loading={isLoading}
                    onClick={handleSubmit}
                    disabled={!isValid}
                  >
                    Заблокировать
                  </Button>
                </Box>
              </Form>
            )}
          </Formik>
        </VStack>
      </Modal>
    </>
  )
}
